import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import clss from 'classnames';
var localCache = {};
var LazyImg = function(props) {
    var defaultElement = props.defaultElement, defaultUrl = props.defaultUrl, url = props.url, className = props.className, alt = props.alt, cacheKey = props.cacheKey;
    var localCacheKey = cacheKey || url;
    var localcacheUrl = localCacheKey && localCache[localCacheKey];
    var ref = useState(''), cacheUrl = ref[0], setCacheUrl = ref[1]; // const setBase64Cache = useCallback(
    //   (img: HTMLImageElement) => {
    //     if (cacheKey) {
    //       const canvas = document.createElement('canvas')
    //       canvas.width = img.width * 2
    //       canvas.height = img.height * 2
    //       const ctx = canvas.getContext('2d')
    //       ctx && ctx.drawImage(img, 0, 0)
    //       const dataURL = canvas && canvas.toDataURL('image/png')
    //       localCache[cacheKey] = dataURL
    //     }
    //   },
    //   [cacheKey, localCache],
    // )
    useEffect(function() {
        if (url) {
            if (!(cacheKey && localCache[cacheKey])) {
                var img = new Image();
                img.onload = function(res) {
                    setCacheUrl(url);
                    if (cacheKey && url) {
                        localCache[cacheKey] = url;
                    }
                };
                img.onerror = function() {
                    setCacheUrl('');
                };
                img.src = url;
            }
        } else {
            setCacheUrl('');
        }
    }, [
        url,
        cacheKey,
        localCache
    ]);
    if (url && (cacheUrl || localcacheUrl)) {
        return(/*#__PURE__*/ _jsx("img", {
            className: clss(className, 'object-cover'),
            src: cacheUrl || localcacheUrl,
            alt: alt
        }));
    }
    if (defaultElement) {
        return defaultElement;
    }
    if (defaultUrl) {
        return(/*#__PURE__*/ _jsx("img", {
            className: clss(className, 'object-cover'),
            src: defaultUrl.toString(),
            alt: "default"
        }));
    }
    return(/*#__PURE__*/ _jsx("img", {
        src: "",
        alt: "defaultUrl or defaultElement is required"
    }));
};
export default LazyImg;
